var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.78 193.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:14.21px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.71,72.93l.09,61.61,48.45-30.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.79,7.1,64.53,18.71,52.93,48.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.44,18.75a86.27,86.27,0,1,0,62.42,1.75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoplay);
export default __webpack_public_path__ + "static/media/autoplay.769d0a9bec086224e1cbabd11c956bf6.svg";
export { ForwardRef as ReactComponent };